import {UIElement} from "./ui";
import '/modules/common/css/ui/loader.css';

class Loader extends UIElement {

    /**
     *
     * @param id {string} loader id
     * @param isMobile {boolean} true if this is a mobile device. false otherwise
     * @param target {jQuery} The target element to append the loader to
     */
    constructor(id, isMobile, target) {
        super(id, undefined, isMobile, undefined, undefined);
        this.target = target;
        this.visible = false;
        if(target)
            this.getUIElement();
    }

    getClassName() {
        return "Loader";
    }

    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $('<div class="loader-container"><div class="loader"></div></div>');
            if (this.target) {
                this.target.append(this.uiElement);
                this.target.css('position','relative');
            }
        }
        return this.uiElement;
    }

    _innerShow(){
        this.uiElement.show();
        this.visible = true;
        this.spin();
    }

    _innerHide(){
        this.uiElement.hide();
        this.visible = false;
    }

    spin(){
        $('.loader',this.uiElement).addClass('spin');
    }
    stopSpin(){
        $('.loader',this.uiElement).removeClass('spin');
    }

    show(immediately) {
        if (!this.visible) {
            if (immediately) {
                this._innerShow();
            } else {
                if (this.timeoutId) {
                    return;
                }
                this.timeoutId = setTimeout(() => {
                    this._innerShow();
                    this.timeoutId = undefined;
                },500);
            }
        }
    }

    hide() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
            this._innerHide();
        }else if (this.visible) {
            this._innerHide();
        }
    }
}

class SmallLoader extends Loader{

    getClassName() {
        return "SmallLoader";
    }

    getUIElement() {
        return super.getUIElement().addClass('small');
    }
}

class ResponsiveWidthLoader extends Loader{

    getClassName() {
        return "ResponsiveWidthLoader";
    }

    getUIElement() {
        return super.getUIElement().addClass('responsive responsive-width');
    }

    _innerShow() {
        this.stopSpin();
        this.setWidth();
        super._innerShow();
        this.stopSpin();
        this.setWidth();
        this.spin();
    }

    setWidth() {
        const h = this.uiElement.height();
        $('.loader', this.uiElement).css('width', h + 'px')
    }
}
class ResponsiveHeightLoader extends Loader{

    getClassName() {
        return "ResponsiveHeightLoader";
    }

    getUIElement() {
        return super.getUIElement().addClass('responsive responsive-height');
    }

    _innerShow() {
        this.stopSpin();
        this.setHeight();
        super._innerShow();
        this.stopSpin();
        this.setHeight();
        this.spin();
    }

    setHeight() {
        const w = this.uiElement.width();
        $('.loader', this.uiElement).css('height', w + 'px')
    }
}

export { Loader, SmallLoader, ResponsiveWidthLoader, ResponsiveHeightLoader }